import { Component, OnDestroy, OnInit } from '@angular/core';
import dayjs from 'dayjs';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { CustomFunctionService } from '@lmc-app/custom-function.service';
import { Router } from '@angular/router';
import {
	UntypedFormBuilder,
	UntypedFormControl,
	UntypedFormGroup,
} from '@angular/forms';
import { Store } from '@ngrx/store';
import { selectUser, State } from '@lmc-app/store';
import { Subject, takeUntil } from 'rxjs';
import { User } from '@lmc-app/shared/interface/user.interface';

@Component({
	selector: 'app-nlsagencyfunded',
	templateUrl: './nlsagencyfunded.component.html',
	styleUrls: ['./nlsagencyfunded.component.scss'],
})
export class NlsagencyfundedComponent implements OnInit, OnDestroy {
	private readonly _onDestroy = new Subject<void>();

	constructor(
		private apiService: LegacyApiService,
		private customFunction: CustomFunctionService,
		private _routerLink: Router,
		private fb: UntypedFormBuilder,
		private store: Store<State>
	) {}

	currentMonth = dayjs().format('MMMM'); // Get the month from current date (e.g., 'November')
	hiddenMonthNum: number;
	nlsFundedMonth: any;
	totalNLSfundedMonth: any;
	countNLSfundedMonth: any;

	monthForm = new UntypedFormGroup({
		months: new UntypedFormControl(''),
	});

	months = [
		{ id: 0, name: 'January' },
		{ id: 1, name: 'February' },
		{ id: 2, name: 'March' },
		{ id: 3, name: 'April' },
		{ id: 4, name: 'May' },
		{ id: 5, name: 'June' },
		{ id: 6, name: 'July' },
		{ id: 7, name: 'August' },
		{ id: 8, name: 'September' },
		{ id: 9, name: 'October' },
		{ id: 10, name: 'November' },
		{ id: 11, name: 'December' },
	];

	ngOnInit(): void {
		this.store
			.select(selectUser)
			.pipe(takeUntil(this._onDestroy))
			.subscribe((user: User | null) => {
				if (user) {
					this.getNLSFundedMonth();

					const monthNum = this.months.findIndex(
						(x) => x.name === this.currentMonth
					);
					this.monthForm = this.fb.group({
						months: [monthNum],
					});
				}
			});
	}

	getNLSFundedMonth() {
		const monthNum = this.months.findIndex((x) => x.name === this.currentMonth);
		this.apiService.getNLSFundedMonth(monthNum).subscribe((res) => {
			this.nlsFundedMonth = res.data;

			this.customFunction.sortColumn(this.nlsFundedMonth, 'TotalAmount', -1, 1); // Sort by descending

			this.totalNLSfundedMonth = this.customFunction
				.sumNumbers(this.nlsFundedMonth, 'TotalAmount')
				.toFixed(2);
			this.countNLSfundedMonth = this.customFunction.sumNumbers(
				this.nlsFundedMonth,
				'AgencyCount'
			);
		});
	}

	selectMonth() {
		this.apiService
			.getNLSFundedMonth(this.monthForm.get('months').value)
			.subscribe((res) => {
				this.hiddenMonthNum = this.monthForm.get('months').value;
				// console.log(this.hiddenMonthNum)
				this.nlsFundedMonth = res.data;

				this.customFunction.sortColumn(
					this.nlsFundedMonth,
					'TotalAmount',
					-1,
					1
				); // Sort by descending

				this.totalNLSfundedMonth = this.customFunction
					.sumNumbers(this.nlsFundedMonth, 'TotalAmount')
					.toFixed(2);
				this.countNLSfundedMonth = this.customFunction.sumNumbers(
					this.nlsFundedMonth,
					'AgencyCount'
				);
			});
	}

	refresh() {
		window.location.reload();
	}

	ngOnDestroy(): void {
		this._onDestroy.next();
		this._onDestroy.complete();
	}
}
